import { render, staticRenderFns } from "./PublicShowcase.vue?vue&type=template&id=115cc036&"
import script from "./PublicShowcase.vue?vue&type=script&lang=ts&"
export * from "./PublicShowcase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports